import React from 'react';
import './DemoDisclaimer.css';

interface DemoDisclaimerProps {
  compact?: boolean;
}

export const DemoDisclaimer: React.FC<DemoDisclaimerProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="demo-disclaimer compact">
        Demo only. Inputs are logged. Rate limited.
      </div>
    );
  }

  return (
    <div className="demo-disclaimer">
      <strong>Demo Notice:</strong> This is a portfolio demonstration. 
      Rate limited to 10 requests/minute globally. 
      Do not submit sensitive information.
    </div>
  );
};

export default DemoDisclaimer;
